import format from "date-fns/format";
import React, { useState } from "react";
import { Flex } from "antd";
import { useTranslation } from "react-i18next";

import Preloader from "~/components/Preloader";
import ReportDocumentControl from "~/pages/BonusQReport/Components/ReportDocumentControl";
import Wrapper from "~/shared/ui/Wrapper";
import { TAppealFilter } from "~/entity/Appeals/model/schema";
import { useSetLocationData } from "~/hooks/locationData";
import { useURLParamsGetter } from "~/hooks/useURLParamsSetter";
import { QReportControl } from "~/pages/BonusQReport/Components/QReportControl/QReportControl";
import { useGetBonusQFileAppeal } from "~/pages/BonusQReport/hooks/useGetBonusQFileAppeal";
import { usePermissions } from "~/shared/context/PermissionContext";
import { AddAppeal } from "~/widgets/Modals/AddAppeal";
import { QReportList } from "~/widgets/QReportList";

import QReportFilter from "./Components/QReportFilter";
import useGetBonusQReport from "./hooks/useGetBonusQReport";

import s from "~/pages/BonusQReport/BonusQReport.less";

const BonusQReport = () => {
  const { t } = useTranslation();

  const [state, setState] = useState<string>(format(new Date(), "yyyy"));
  const { data, isLoading, isError } = useGetBonusQReport({ param: state });
  const { data: dataFile } = useGetBonusQFileAppeal();

  const changeDate = (date: string) => {
    setState(date);
  };

  return (
    <Wrapper.Content
      title={"Квартальные отчеты по бонусной системе - малус по обучению"}
      controlComponent={<QReportControl />}
      filterComponent={<QReportFilter changeDate={changeDate} />}
      filterControlClassName={s.filterReplacement}
    >
      <Flex
        style={{ width: "100%", marginTop: 10 }}
        gap={16}
        align={"center"}
        vertical
      >
        {isLoading && !isError ? (
          <Preloader />
        ) : isError ? (
          <div className={s.not_data}>нет данных</div>
        ) : (
          <QReportList reports={data?.items} />
        )}

        <div style={{ marginTop: 20 }}>
          <ReportDocumentControl
            label={t("appeal.appealSubmissionOrder")}
            id={dataFile?.file?.fileId}
            link={dataFile?.file?.link}
          />
        </div>
      </Flex>
    </Wrapper.Content>
  );
};

export default BonusQReport;
